import { useAuthorizedQuery } from "../api/authorized-query";
import { seedgreenAPI } from "../api/axios";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
export function useSaveTaskRequest() {
    const queryClient = useQueryClient();
    const isAuthorized = useAuthorizedQuery();
    const { mutateAsync, status, error } = useMutation({
        mutationFn: async (taskRequest) => {
            if (!isAuthorized.value)
                return;
            const response = await seedgreenAPI.put("v2/TaskRequest", taskRequest);
            return response.data;
        },
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({
                queryKey: ["task-requests"],
            });
            // Invalidate plantings queries to ensure planting data gets refetched
            // This ensures the planting name shows up immediately for the new task request
            if (variables.plantingId) {
                queryClient.invalidateQueries({
                    queryKey: ["plantings", "byIds"],
                });
            }
        },
    });
    return {
        saveTaskRequest: mutateAsync,
        status,
        error,
    };
}
